import { Box, Link, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import ContactCard from "../components/ContactCard";
import PageLayout from "../components/PageLayout";
import { useApi } from "../hooks/useApi";
import { Contact } from "../types/contact";

interface Props {}

const Home: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { data: contactsQuery } = useApi<Contact[]>("contacts", undefined, {
    page: 1,
    count: 6,
  });

  return (
    <PageLayout header={t("contacts.title")}>
      <Box sx={{ pb: 4 }}>
        <Typography variant="body1">
          {t("contacts.feedbackText")}{" "}
          <Link href={"mailto: feedback@teacheractive.com"}>
            feedback@teacheractive.com
          </Link>
          .
        </Typography>
      </Box>

      <Stack
        direction={isSmallScreen ? "column" : "row"}
        flexWrap="wrap"
        alignItems={"center"}
        padding={0}
      >
        {contactsQuery?.results?.map((contact, index) => (
          <ContactCard key={`contacts-${index}`} data={contact} />
        ))}
      </Stack>
    </PageLayout>
  );
};

export default Home;
